var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['ElIcon', _vm.name],style:(_vm.iconStyle),attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }